// extracted by mini-css-extract-plugin
module.exports = {"ol":"F-list-ol-17pC0","ul":"F-list-ul-1XuyG","li":"F-list-li-263FC"};